export const routes = [
  {
    path: "/cidade/:id/cliente-oculto",
    component: () => import("./components/List"),
    name: "city.clienteoculto.selo",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cidade/:id/cliente-oculto/info",
    component: () => import("./components/Info"),
    name: "city.clienteoculto.info",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cliente-oculto/selo/download/:evidenceId",
    component: () => import("./components/DownloadImagensSelo"),
    name: "clienteoculto.selo.download",
  },
];
